import {ReadingPart} from "./steps/types";
import {InstructionsStep} from "./steps/InstructionsStep";
import {MazeQuestion} from "./steps/MazeQuestion";
import {OralReadingQuestion} from "./steps/OralReadingQuestion";
import {VocabularyQuestion} from "./steps/VocabularyQuestion";
import {RecapStep} from "./steps/RecapStep";


export const readingSteps: ReadingPart[] = [
    {
        key: "instructions",
        requestStep: "instructions",
        shouldFetch: true,
        component: InstructionsStep,
        lastStep: false,
    },
    {
        key: "part1-maze",
        requestStep: "instructions",
        shouldFetch: true,
        includePart: true,
        partOrder: 1,
        requiresCompletion: true,
        component: MazeQuestion,

    },
    {
        key: "part1-oral-reading",
        requestStep: "part1-maze",
        shouldFetch: false,
        requiresCompletion: true,
        component: OralReadingQuestion,
    },
    {
        key: "part1-vocab",
        requestStep: "part1-oral-reading",
        shouldFetch: false,
        requiresCompletion: true,
        component: VocabularyQuestion,
    },
    {
        key: "part2-maze",
        requestStep: "instructions",
        shouldFetch: true,
        includePart: true,
        partOrder: 2,
        requiresCompletion: true,
        component: MazeQuestion,
    },
    {
        key: "part2-oral-reading",
        requestStep: "part2-maze",
        shouldFetch: false,
        requiresCompletion: true,
        component: OralReadingQuestion,
    },
    {
        key: "part2-vocab",
        requestStep: "part2-oral-reading",
        shouldFetch: false,
        requiresCompletion: true,
        component: VocabularyQuestion,
    },
    {
        key: "part3-maze",
        requestStep: "instructions",
        shouldFetch: true,
        includePart: true,
        partOrder: 3,
        requiresCompletion: true,
        component: MazeQuestion,
    },
    {
        key: "part3-oral-reading",
        requestStep: "part3-maze",
        shouldFetch: false,
        requiresCompletion: true,
        component: OralReadingQuestion,
    },
    {
        key: "part3-vocab",
        requestStep: "part3-oral-reading",
        shouldFetch: false,
        requiresCompletion: true,
        component: VocabularyQuestion,
    },
    {
        key: "reading-recap",
        requestStep: "instructions",
        shouldFetch: true,
        requiresCompletion: true,
        lastStep: true,
        component: RecapStep,
    }
];